import request from '@/utils/request'

const login = (params) => {
  return request({
    url: `/auth/login`,
    data: params,
    method: 'post'
  })
}

const auth = (token) => {
  return request({
    url: '/auth/auth/user',
    params: token,
    method: 'get'
  })
}
const authInfo = () => {
  return request({
    url: '/auth/user',
    method: 'get'
  })
}

const modifyPwd = (params) => {
  return request({
    url: '/auth/user/pwd',
    data: params,
    method: 'put'
  })
}

const modifyHeadPic = (headPic) => {
  return request({
    url: '/auth/user',
    data: headPic,
    method: 'put'
  })
}
const codeChangePassword = (params) => {
  return request({
    url: `/auth/user/phone/pwd`,
    method: 'put',
    data: params
  })
}
const getMsgCode = (params) => {
  return request({
    url: `/auth/user/phone/code`,
    method: 'post',
    data: params
  })
}
const bindPhone = (params) => {
  return request({
    url: `/auth/user/phone`,
    method: 'put',
    data: params
  })
}
const getPhoneLogin = (params) => {
  return request({
    url: `/auth/login/phone/code`,
    method: 'post',
    data: params
  })
}
export {
  login, // 用户登录
  auth, // 认证服务
  authInfo, // 获取用户信息
  modifyPwd, // 修改密码
  modifyHeadPic, // 修改用户头像
  codeChangePassword,
  getMsgCode,
  bindPhone,
  getPhoneLogin
}
